import state from './reviewListState'
import mutations from './reviewListMutations'
import actions from './reviewListActions'
import getters from './reviewListGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
